import React, { useEffect } from 'react';
import { NextPage } from 'next';
import { useDispatch } from 'react-redux';

import { useLazyQuery } from '@apollo/client';
import { setAvailablePlans } from '@/redux/plans/actions';
import { setUF } from '@/redux/uf/actions';
import { unsetError } from '@/redux/app/actions';

import LayoutCustom from '../../components/LayoutCustom';
import PricesAndPlans from '../../components/PricesAndPlans';
import { getPlansService, getUFService } from '@/graphQL/onLoad/getProps';
import { UF } from '@/src/types/uf';
import { trackEvent } from '@/utils/dataLayer/baseDataLayer';
import { planPageEvents } from '@/utils/dataLayer/planPage';
import { useBranding } from '@/src/customHooks';
import listPlansAndUFToday from '@/graphQL/queries/listPlansAndUFToday';

const PricesAndPlansPage: NextPage<{ getUFToday: UF; listPlans: unknown }> = ({
  getUFToday,
  listPlans,
}) => {
  const dispatch = useDispatch();
  const { code } = useBranding();

  const [getInitialData, { loading }] = useLazyQuery(listPlansAndUFToday, {
    onCompleted: (data) => {
      if (data) {
        dispatch(setAvailablePlans(data.listPlans));
        dispatch(setUF(data.getUFToday));
        dispatch(unsetError());
      }
    },
  });

  useEffect(() => {
    if (!!code) {
      getInitialData({ variables: { brokerCode: code } });
    }
    dispatch(setAvailablePlans(listPlans));
    dispatch(setUF(getUFToday));
    dispatch(unsetError());
  }, [code]);

  useEffect(() => {
    trackEvent({
      eventParams: {
        ...planPageEvents.home,
      },
    });
  }, []);

  const eventParams = {
    ...planPageEvents.hiringFloatClick,
  };

  return (
    <LayoutCustom eventParams={eventParams}>
      <PricesAndPlans loading={loading} />
    </LayoutCustom>
  );
};

export async function getStaticProps() {
  let getUFToday = null;
  let listPlans = null;

  try {
    getUFToday = await getUFService();
    listPlans = await getPlansService();
  } catch (error) {
    console.error('getStaticProps: failed to fetch initial data', error);
  }

  return {
    revalidate: process.env.STAGE === 'prod' ? 300 : 30,
    props: {
      getUFToday,
      listPlans,
    },
  };
}

export default PricesAndPlansPage;
